





























































































import { GetMenuList, SaveMenu, GetConfigureProjects } from "@/api/sys";
import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";

/**
 * 菜单管理
 */
@Component
export default class extends AbpBase {
  form: any = { configureType: "无" };
  menus: any = [];
  loading = false;
  projectShow = false;
  configureProjects: any[] = [];
  configureProjectAll: any = {};
  buttonProps: any = {
    type: "default",
    size: "small",
  };
  rules = {
    menuName: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
    sort: [{ required: true, message: "请输入排序码", trigger: "blur" }],
    icon: [{ required: true, message: "请输入图标", trigger: "blur" }],
    permission: [
      { required: true, message: "请输入权限编码", trigger: "blur" },
    ],
    routeName: [{ required: true, message: "请输入路由编码", trigger: "blur" }],
    routePath: [{ required: true, message: "请输入路由PATH", trigger: "blur" }],
  };

  created() {
    this.init();
  }

  async init() {
    this.loading = true;
    let res = await GetMenuList();
    let menuData = res.objects;
    let nodeList = [];
    let pList = menuData.filter((x) => x.parentMenuCode == "0");
    pList.forEach((p) => {
      let cList = menuData.filter((x) => x.parentMenuCode == p.menuCode);
      let children = [];
      cList.forEach((c) => {
        let cNode = {
          title: c.menuName,
          expand: true,
          data: { parentMenuName: p.menuName, ...c },
        };
        children.push(cNode);
      });
      let pNode = {
        title: p.menuName,
        expand: false,
        children: children,
        data: p,
      };
      nodeList.push(pNode);
    });
    let configureProjects = await GetConfigureProjects();
    this.configureProjectAll = configureProjects.objects;
    this.menus = [
      {
        title: "菜单",
        expand: true,
        render: (h1, { root, node, data }) => {
          let h = this.$createElement;
          return h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
              },
            },
            [
              h("span", [
                h("Icon", {
                  props: {
                    type: "ios-folder-outline",
                  },
                  style: {
                    marginRight: "8px",
                  },
                }),
                h("span", data.title),
              ]),
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    float: "right",
                    marginRight: "32px",
                  },
                },
                [
                  h("Button", {
                    props: Object.assign({}, this.buttonProps, {
                      icon: "md-add",
                      type: "primary",
                    }),
                    style: {
                      width: "64px",
                    },
                    on: {
                      click: () => {
                        this.append(data);
                      },
                    },
                  }),
                ]
              ),
            ]
          );
        },
        children: nodeList,
        data: {
          menuCode: "0",
          menuName: "菜单"
        },
      },
    ];
    this.loading = false;
    console.log(this.menus)
  }

  renderContent(h1, { root, node, data }) {
    let h = this.$createElement;
    return h(
      "span",
      {
        style: {
          display: "inline-block",
          width: "100%",
          cursor: "pointer",
          color: node.node.selected ? "#e91e63" : "#000",
          fontWeight: node.node.selected ? 'bold' : 'normal',
        },
        on: {
          click: () => {
            let obj = Object.assign({}, data.data);
            obj.isAssessForm = obj.isAssessForm == true;
            this.form = obj;
            this.projectChange();

            if (!node.node.selected) {
              (this.$refs.tree as any).handleSelect(node.nodeKey);
            }
          },
        },
      },
      [
        h("span", [
          h("Icon", {
            props: {
              type: "ios-paper-outline",
            },
            style: {
              marginRight: "8px",
            },
          }),
          h("span", data.title),
        ]),
        h(
          "span",
          {
            style: {
              display: "inline-block",
              float: "right",
              marginRight: "32px",
            },
          },
          [
            h("Button", {
              props: Object.assign({}, this.buttonProps, {
                icon: "md-add",
              }),
              style: {
                marginRight: "8px",
              },
              on: {
                click: () => {
                  this.append(data);
                },
              },
            }),
            h("Button", {
              props: Object.assign({}, this.buttonProps, {
                icon: "md-trash",
              }),
              on: {
                click: () => {
                  this.remove(root, node, data);
                },
              },
            }),
          ]
        ),
      ]
    );
  }

  append(data) {
    const children = data.children || [];
    children.push({
      title: "请输入菜单名称",
      expand: true,
      data: {
        menuCode: this.guid(),
        menuName: "请输入菜单名称",
        parentMenuCode: data.data.menuCode,
        parentMenuName: data.data.menuName,
        icon: "&#xe6d5;",
      },
    });
    this.$set(data, "children", children);
  }

  remove(root, node, data) {
    this.$Message.error("暂未提供删除菜单的功能，请联系工程师处理！");
    return;
    this.$Modal.confirm({
      title: "提示",
      content: "确定要删除吗？",
      onOk: () => {
        const parentKey = root.find((el) => el === node).parent;
        const parent = root.find((el) => el.nodeKey === parentKey).node;
        const index = parent.children.indexOf(data);
        parent.children.splice(index, 1);
      },
    });
  }

  handeNodeSelect(data: any) {
    console.log(data);
  }

  async save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        let res = await SaveMenu(this.form);
        if (res.code == 2000) {
          this.init();
        }
        this.loading = false;
      }
    });
  }
  projectChange() {
    this.projectShow = false;
    this.configureProjects = [];
    if (this.form.configureType == "表单") {
      this.configureProjects = this.configureProjectAll.projectsForm;
      this.form.routePath = "@/views/tool/sqlMaintain/sqlForFrom";
    } else if (this.form.configureType == "统计") {
      this.configureProjects = this.configureProjectAll.projectsSql;
      this.form.routePath = "@/views/tool/sqlMaintain/sqlForData";
    } else if (this.form.configureType == "BI报表") {
      this.configureProjects = this.configureProjectAll.projectsBIReport;
      this.form.routePath = "@/views/tool/biReport/preview";
    }else if (this.form.configureType == "标签页") {
      this.configureProjects = this.configureProjectAll.projectsTab;
      this.form.routePath = "@/views/tool/tabMaintain/tabForData";
    }
    this.projectShow = true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/menus/index.vue